class NutritionTabs {
  constructor() {
    this.tabPanels();
  }

  tabPanels() {
    $(function() {
      $('.panels').css('height', $('.panels__body.active').height());
    })
    $('.tabs__item button').on('click', function () {
      const tabValue = $(this).data('tab');
      const panelHeight = $(`[data-panel="${tabValue}"]`).height();


      $(this).parent().addClass('active');
      $('.tabs__item').not($(this).parent()).removeClass('active');

      $(this).parent().parent().attr('class', 'tabs__list');
      $(this).parent().parent().addClass(`${tabValue}-active`)

      $(`.panels__body:not([data-panel="${tabValue}"])`).removeClass('active');
      $(`[data-panel="${tabValue}"]`).addClass('active');

      $('.panels').css('height', panelHeight);
    })
  }
}

export default NutritionTabs;
